import { combineReducers } from 'redux-immutable'

import accountingPeriod from './accountingPeriod/reducer'
import area from './area/reducer'
import assetCategory from './assetCategory/reducer'
import assetCode from './assetCode/reducer'
import cause from './cause/reducer'
import department from './department/reducer'
import excise from './excise/reducer'
import exciseSetting from './exciseSetting/reducer'
import ledgerSetting from './ledgerSetting/reducer'
import role from './role/reducer'
import submitDestination from './submitDestination/reducer'

export default combineReducers({
  assetCategory,
  area,
  excise,
  submitDestination,
  cause,
  department,
  accountingPeriod,
  ledgerSetting,
  assetCode,
  exciseSetting,
  role,
})
